'use client'

import { hasAdConsent } from '@/utils/attribution'
import { sendGAEvent } from '@next/third-parties/google'

// Conversion-IDs kommen aus Vercel-Env-Variablen; ohne gesetzten Wert wird der
// jeweilige Kanal still übersprungen (kein Platzhalter-Traffic mehr).
const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID
const GOOGLE_ADS_LEAD_LABEL = process.env.NEXT_PUBLIC_GOOGLE_ADS_LEAD_LABEL
// Eigene Ads-Action für gebuchte Termine. Solange sie nicht angelegt ist,
// meldet die Buchung wie bisher an das Lead-Label (kein Verhaltensbruch).
const GOOGLE_ADS_BOOKING_LABEL = process.env.NEXT_PUBLIC_GOOGLE_ADS_BOOKING_LABEL
const LINKEDIN_CONVERSION_ID = process.env.NEXT_PUBLIC_LINKEDIN_CONVERSION_ID

export function trackEvent(name: string, params: Record<string, string | number | boolean> = {}) {
  try {
    sendGAEvent('event', name, params)
  } catch {
    // Analytics darf nie die UI brechen
  }
}

// Event-Parameter heisst bewusst cta_source und nicht source: "source" ist in
// GA4 reserviert und überschrieb die Sitzungsquelle (aus google / cpc wurde
// z. B. "kontakt-form-alt").

/** Klick auf einen Calendly-CTA (noch keine Buchung). */
export function trackCalendlyClick(source: string) {
  trackEvent('calendly_click', { cta_source: source })
}

/**
 * Tatsächlich gebuchter Calendly-Termin (calendly.event_scheduled),
 * das eigentliche Conversion-Ereignis des Haupt-Funnels.
 */
export function trackCalendlyBooked(source: string) {
  trackEvent('calendly_booked', { cta_source: source })
  fireAdsConversions(source, GOOGLE_ADS_BOOKING_LABEL || GOOGLE_ADS_LEAD_LABEL)

  if (window.fbq) {
    window.fbq('track', 'Schedule', { content_name: source })
  }
}

/** Erfolgreich abgeschicktes Lead-/Kontaktformular. */
export function trackLeadFormSubmit(source: string, userData: { email?: string } = {}) {
  trackEvent('lead_form_submit', { cta_source: source })

  // Enhanced Conversions: gtag hasht die Adresse selbst (SHA-256) vor dem
  // Versand. Nur mit Einwilligung in Werbe-Cookies (ad_user_data).
  const email = userData.email?.trim().toLowerCase()
  if (email && window.gtag && hasAdConsent()) {
    try {
      window.gtag('set', 'user_data', { email })
    } catch {
      // Analytics darf nie die UI brechen
    }
  }

  fireAdsConversions(source, GOOGLE_ADS_LEAD_LABEL)

  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: source,
      content_category: 'Lead Generation'
    })
  }
}

/** Eindeutige ID je Conversion, damit Google Ads Dubletten verwirft. */
function createTransactionId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  } catch {
    // randomUUID fehlt in unsicheren Kontexten (http) und älteren Browsern
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

function fireAdsConversions(source: string, label: string | undefined) {
  if (GOOGLE_ADS_ID && label && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${label}`,
      value: 1.0,
      currency: 'EUR',
      transaction_id: createTransactionId(),
      event_source: source
    })
  }

  if (LINKEDIN_CONVERSION_ID && window.lintrk) {
    window.lintrk('track', { conversion_id: LINKEDIN_CONVERSION_ID })
  }
}
